import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { AutoLogoutComponent } from "./shared/components/auto-logout";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  standalone: true,
  imports: [RouterOutlet, AutoLogoutComponent],
})
export class AppComponent {}
